import { render, staticRenderFns } from "./PageAlarmsTabMain.vue?vue&type=template&id=83b02a20&scoped=true&"
import script from "./PageAlarmsTabMain.vue?vue&type=script&lang=ts&"
export * from "./PageAlarmsTabMain.vue?vue&type=script&lang=ts&"
import style0 from "./PageAlarmsTabMain.vue?vue&type=style&index=0&id=83b02a20&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83b02a20",
  null
  
)

export default component.exports